import type { Member } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page/types';
import { fetchCurrentUserSuccess } from './fetch-current-user';

type CurrentUserState = Member | null;

type AnyAction = ReturnType<typeof fetchCurrentUserSuccess>;

export default (state: CurrentUserState = null, action: AnyAction): CurrentUserState => {
  switch (action.type) {
    case fetchCurrentUserSuccess.type:
      return action.payload ?? null;
    default:
      return state;
  }
};
